import { buildExcelInBackground } from "./excelWorkerClient";

export async function buildExcelBuffer(sheetName: string, rows: Record<string, unknown>[]) {
  return buildExcelInBackground(sheetName, rows);
}

export async function downloadExcel(fileName: string, sheetName: string, rows: Record<string, unknown>[]) {
  const buffer = await buildExcelBuffer(sheetName, rows);
  const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
  const url = URL.createObjectURL(blob); const link = document.createElement("a");
  link.href = url; link.download = fileName.endsWith(".xlsx") ? fileName : `${fileName}.xlsx`; link.click(); URL.revokeObjectURL(url);
}
